import { Outlet } from "react-router-dom";
import Header from "./header/Header";

const LayoutLinks = () => {
  return (
    <>
      <Header inPage={false} />
      <div className="container">
        <Outlet />
      </div>
    </>
  );
};

export default LayoutLinks;
